import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from '../models/auth.models';

@Injectable({ providedIn: 'root' })
export class UserProfileService {
	constructor(private http: HttpClient) {}
	/***
	 * Get All User
	 */
	getAll() {
		return this.http.get<User[]>(`api/users`);//no encontrada
	}

	/***
	 * Facked User Register
	 */
	register(user: User) {
		return this.http.post(`/users/register`, user);//no encontrada
	}
}
